export default "__VITE_ASSET__b2sY0XdA__"